import HBTab from "@/components/HBTab";
import classNames from "classnames";
import { useMemo } from "react";
import { When } from "react-if";
import BoardListPanel from "./components/BoardListPanel";
import MusePinListPanel from "./components/MusePinListPanel";
import MyFavorite from "./components/MyFavorite";
import PinListPanel from "./components/PinListPanel";
import RecycleBoardListPanel from "./components/RecycleBoardListPanel";
import Summary from "./components/Summary";
import TagListPanel from "./components/TagListPanel";
import styles from "./index.module.less";
import useViewModel, { TAB } from "./viewModel";

export { TAB } from "./viewModel";

/**
 * @param {{
 *   targetUrlname?: string;
 *   user?: any;
 *   openTab?: string;
 *   tagName?: string;
 *   query?: any;
 *  initBoards:Array;
 *  headerHeight: number; // 头部高度
 * }} props
 * @returns {JSX.Element|null}
 * @constructor
 */
export default function UserInfo({
  initBoards,
  initPins,
  initMusePins,
  initLikesPins,
  initLikesBoards,
  initLikesTopics,
  initTags,
  initTagPins,
  ...props
}) {
  const { currentTab, user, userStore, tagName } = useViewModel(props);

  const isMe = userStore.user?.user_id === user?.user_id;

  const isBlocked = useMemo(() => {
    return user?.blacklisted;
  }, [user]);

  // 是否显示页面框架
  const showPageFrame = useMemo(() => {
    return ![TAB.LIKES].includes(currentTab); // 喜欢页面不显示页面框架
  }, [currentTab]);

  // 用户中心tab按钮
  const tabButtons = useMemo(
    () => [
      {
        title: "全部",
        key: TAB.PINS,
        href: `/user/${user?.urlname}/${TAB.PINS}`,
      },
      {
        title: "发布",
        key: TAB.CREATED,
        href: `/user/${user?.urlname}/${TAB.CREATED}`,
        userGuideTooltip: {
          title: `原“创建的”已更名为“发布”`,
          localStorageKey: "user_page_guide_7--new",
          placement: "bottom",
          needUserId: false,
        },
      },
      {
        title: "采集",
        key: TAB.BOARDS,
        href: `/user/${user?.urlname}`,
      },
      // {
      //   title: "全部采集的",
      //   key: TAB.PINS,
      //   href: `/user/${user?.urlname}/pins`,
      // },
      // {
      //   title: "标签",
      //   key: TAB.TAGS,
      //   href: `/user/${user?.urlname}/tags`,
      // },
      // {
      //   title: "喜欢",
      //   key: TAB.LIKES,
      //   href: `/user/${user?.urlname}/likes`,
      // },
    ],
    [user?.urlname]
  );

  return (
    <div className={classNames("calculateWrapper", styles.userCenter)}>
      <When condition={showPageFrame}>
        {/* 用户信息 */}
        <Summary user={user} isMe={isMe} />
      </When>

      <div className={styles.container}>
        <When condition={showPageFrame}>
          {/* Tab按钮 */}
          <HBTab
            tabs={tabButtons}
            currentTab={currentTab}
            className={styles.tab}
          />
        </When>

        {isBlocked ? (
          <div className={styles.blocked}>由于对方设置，你无法查看Ta的主页</div>
        ) : (
          <>
            {/* 画板管理 */}
            {currentTab === TAB.BOARDS && (
              <BoardListPanel
                userStore={userStore}
                user={user}
                isMe={isMe}
                initBoards={initBoards}
                initPins={initPins}
                hideCreateBtn={true}
                showUnorganizedPinList={true}
                showUnorganized={false}
                showActions
                useLocalStorageSort={false}
              />
            )}

            {/* 采集列表 和 全部采集的 */}
            {[TAB.PINS, TAB.CREATED].includes(currentTab) && (
              <PinListPanel
                user={user}
                isMe={isMe}
                hideCreateBtn={true}
                initPins={initPins}
                userStore={userStore}
                created={currentTab === TAB.CREATED}
              />
            )}

            {/* 原创管理 */}
            {currentTab === TAB.CREATIONS && (
              <MusePinListPanel
                user={user}
                isMe={isMe}
                initMusePins={initMusePins}
              />
            )}

            {/* "喜欢"管理 */}
            {currentTab === TAB.LIKES && (
              <MyFavorite
                initLikesPins={initLikesPins}
                initLikesBoards={initLikesBoards}
                initLikesTopics={initLikesTopics}
                user={user}
                isMe={isMe}
              />
            )}

            {/* 标签管理 */}
            {currentTab === TAB.TAGS && (
              <TagListPanel
                urlname={user.urlname}
                tagName={tagName}
                userStore={userStore}
                isMe={isMe}
                initTags={initTags}
                initTagPins={initTagPins}
              />
            )}

            {/* 回收站 */}
            {currentTab === TAB.RECYCLE && (
              <RecycleBoardListPanel
                urlname={user.urlname}
                userStore={userStore}
                isMe={isMe}
              />
            )}
          </>
        )}
      </div>
    </div>
  );
}
